import React, { useEffect, useState } from 'react';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import EinvoiceEwaybillIntegrationActions from '@Actions/integrations/einvoiceEwaybillActions';
import UserActions from '@Actions/userActions';
import Helpers from '@Apis/helpers';
import {
  Button, Checkbox, DatePicker, Popconfirm, Table, notification, Input, Alert,
} from 'antd';
import './style.scss';
import dayjs from 'dayjs';
import { EyeInvisibleOutlined, EyeTwoTone, LoadingOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';

const AuthDrawer = ({
  GSTAuthentication, user, getUserProfile, GSTAuthenticationLoading, enableEinvoiceEwaybillLoading, enableEinvoiceEwaybill, GSTDeauthenticationLoading, GSTDeauthentication,
}) => {
  const data = [
    {
      key: '1',
      revenue: 500,
      date: '2020-10-10',
    },
    {
      key: '2',
      revenue: 100,
      date: '2021-10-01',
    },
    {
      key: '3',
      revenue: 50,
      date: '2021-04-01',
    },
    {
      key: '4',
      revenue: 20,
      date: '2022-04-01',
    },
    {
      key: '5',
      revenue: 10,
      date: '2022-10-01',
    },
  ];
  const columns = [
    {
      title: 'BUSINESS TURNOVER',
      dataIndex: 'revenue',
      render: (text) => <div>{`Revenue > ${text} crores`}</div>,
    },
    {
      title: 'START DATE',
      dataIndex: 'date',
      render: (text) => <div>{`Any date after ${dayjs(text, 'YYYY-MM-DD').format('DD/MM/YYYY')}`}</div>,
      align: 'right',
    },
  ];

  const [userName, setUserName] = useState('');
  const [initialUsername, setInitialUsername] = useState('');
  const [initialConnected, setInitialConnected] = useState(false);
  const [password, setPassword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isEinvoiceEnabled, setIsEinvoiceEnabled] = useState(false);
  const [selectedRowKey, setSelectedRowKey] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [isUserReady, setIsUserReady] = useState(true);
  const apiCall = () => {
    setFormSubmitted(true);
    if (!userName || !password || (isEinvoiceEnabled && (!startDate || !selectedRow?.length))) {
      notification.open({
        type: 'error',
        message: 'Please fill all the mandatory fields.',
        duration: 4,
        placement: 'top',
      });
    } else {
      const modifieddate = dayjs(startDate).format('YYYY-MM-DD');
      const payload = selectedRow.map((item) => {
        const turnOverType = `${item.revenue}+`;
        return {
          start_date: modifieddate,
          turn_over_type:
          turnOverType,
          gstin: user?.tenant_info?.gst_number,
          username: userName,
          password,
          tenant_id: user?.tenant_info?.tenant_id,
          is_e_invoicing_enabled: isEinvoiceEnabled,
        };
      });
      GSTAuthentication(payload?.[0], () => { getUserProfile(); });
    }
  };
  const apiCallDeauthentication = () => {
    const payload = {
      gstin: user.user_tenants.find((tenant) => tenant.tenant_id === user.tenant_info.tenant_id)?.gst_number,
      tenant_id: user?.tenant_info?.tenant_id,
    };
    GSTDeauthentication(payload, () => { getUserProfile(); });
  };

  useEffect(() => {
    if (isUserReady) {
      const tenantInfo = user?.user_tenants?.find((i) => i?.tenant_id === user?.tenant_info?.tenant_id);
      if (tenantInfo?.is_e_way_bill_enabled) {
        setInitialConnected(true);
        setInitialUsername(tenantInfo?.username);
        setUserName(tenantInfo?.username);
      }
      if (tenantInfo?.is_e_invoicing_enabled) {
        setIsEinvoiceEnabled(true);
        setStartDate(tenantInfo?.start_date ? dayjs(tenantInfo?.start_date, 'YYYY-MM-DD') : '');
        const turnover = Number(tenantInfo?.turn_over_type?.replaceAll('+', ''));
        setSelectedRow([data?.find((i) => i?.revenue === turnover)]);
        setSelectedRowKey([data?.find((i) => i?.revenue === turnover)?.key]);
      }
      setIsUserReady(false);
    }
  }, [isUserReady]);
  return (
    <div className="auth-drawer_wrapper">
      {initialConnected && (
        <div className="e-way-connected">
          <div className="e-way-connected-username">
            <FontAwesomeIcon icon={faCircleCheck} />
            <H3Text text={initialUsername} className="" />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to disconnect E-Way Bill Portal?"
            onConfirm={() => {
              apiCallDeauthentication();
            }}
            okText="Yes"
            cancelText="No"
          >
            <H3Text text={GSTDeauthenticationLoading ? <LoadingOutlined /> : 'disconnect'} className="e-way-connected__action" />
          </Popconfirm>
        </div>
      )}
      <p className="drawer-gst-input__label">
        GST Number
      </p>
      <H3FormInput
        name="GST Number"
        type="text"
        containerClassName="orgInputContainer-drawer"
        labelClassName="orgFormLabel"
        inputClassName="orgFormInput"
        placeholder="Username here.."
        disabled
        value={user?.tenant_info?.gst_number}
        maxlength="100"
      />
      <p className="drawer-gst-input__label">
        Enter Username
        {' '}
        <span className="color-red">
          *
        </span>
        {' '}
      </p>
      <H3FormInput
        name="Username"
        type="text"
        containerClassName="orgInputContainer-drawer"
        labelClassName="orgFormLabel"
        inputClassName="orgFormInput"
        placeholder="Username"
        onChange={(value) => {
          setUserName(value.target.value);
        }}
        disabled={GSTAuthenticationLoading || GSTDeauthenticationLoading || enableEinvoiceEwaybillLoading}
        value={userName}
        maxlength="100"
        required
        showError={formSubmitted && userName === ''}
      />
      <p className="drawer-gst-input__label">
        Password
        {' '}
        <span className="color-red">
          *
        </span>
        {' '}
      </p>
      <div className="orgInputContainer">
        <Input.Password
          placeholder="input password"
          iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          onChange={(value) => {
            setPassword(value.target.value);
          }}
          value={password}
          rootClassName="password-input"
          disabled={GSTAuthenticationLoading || enableEinvoiceEwaybillLoading || GSTDeauthenticationLoading}
        />
        {formSubmitted && !password && (
          <div className="input-error">
            *Please enter password
          </div>
        )}
      </div>
      {user?.tenant_info?.sales_config?.addons?.e_invoicing?.is_active && Helpers.getPermission(Helpers.permissionEntities.E_INVOICE, Helpers.permissionTypes.UPDATE, user) && (
        <div className="drawer-vq__header-field">
          <Checkbox onChange={() => { setIsEinvoiceEnabled(!isEinvoiceEnabled); }} checked={isEinvoiceEnabled}>Enable e-Invoicing</Checkbox>
        </div>
      )}
      {user?.tenant_info?.sales_config?.addons?.e_invoicing?.is_active && Helpers.getPermission(Helpers.permissionEntities.E_INVOICE, Helpers.permissionTypes.UPDATE, user) && isEinvoiceEnabled && !isUserReady && (
        <div className="">
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            size="small"
            rowSelection={{
              type: 'radio',
              onChange: (rowKey, row) => {
                setSelectedRowKey(rowKey);
                setSelectedRow(row);
              },
              selectedRowKey,
            }}
          />
          { (formSubmitted && selectedRow.length === 0) && (

            <span className="color-red" style={{ marginTop: '5px', fontSize: '12px', marginBottom: '5px' }}>
              *  Please Select a turnover
            </span>

          )}
          <p className="drawer-gst-input__label">
            Start Date
            {' '}
            <span className="color-red">
              *
            </span>
            {' '}
          </p>

          <DatePicker
            className="orgInputContainer-drawer "
            value={startDate}
            format="YYYY-MM-DD"
            onChange={(date) => {
              setStartDate(date);
            }}
            disabled={GSTAuthenticationLoading || GSTDeauthenticationLoading || enableEinvoiceEwaybillLoading}
            style={{
              height: '32px',
              width: '100%',
              borderRadius: '3px',
            }}
          />
          { (formSubmitted && startDate === '') && (

            <span className="color-red" style={{ marginTop: '5px', fontSize: '12px' }}>
              *  Please enter Date
            </span>

          )}

        </div>
      )}

      <div className="gst__footer">

        <H3Button
          text="Save & Validate "
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          customClass="gst__footer-submit"
          disabled={GSTAuthenticationLoading || GSTDeauthenticationLoading || enableEinvoiceEwaybillLoading}
          onClick={() => {
            apiCall();
          }}
          isLoading={GSTAuthenticationLoading || enableEinvoiceEwaybillLoading}
        />
      </div>

    </div>
  );
};

const mapStateToProps = ({ EinvoiceEwaybillReducers, UserReducers }) => ({
  enableEinvoiceEwaybillLoading: EinvoiceEwaybillReducers.enableEinvoiceEwaybillLoading,
  GSTAuthenticationLoading: EinvoiceEwaybillReducers.GSTAuthenticationLoading,
  GSTDeauthenticationLoading: EinvoiceEwaybillReducers.GSTDeauthenticationLoading,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  enableEinvoiceEwaybill: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.enableEinvoiceEwaybill(payload, callback)),
  GSTAuthentication: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.GSTAuthentication(payload, callback)),
  GSTDeauthentication: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.GSTDeauthentication(payload, callback)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
});

AuthDrawer.propTypes = {
  user: PropTypes.any,
  GSTAuthentication: PropTypes.func,
  GSTDeauthentication: PropTypes.func,
  enableEinvoiceEwaybillLoading: PropTypes.bool,
  GSTAuthenticationLoading: PropTypes.bool,
  GSTDeauthenticationLoading: PropTypes.bool,
  enableEinvoiceEwaybill: PropTypes.func,
  getUserProfile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthDrawer));
